var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy": "FormPurchaseLimit-customerId",
                      filled: "",
                      label: _vm.$$t("customer"),
                      "item-text": "customerDesc",
                      "item-value": "customerId",
                      items: _vm.availableCustomers,
                    },
                    model: {
                      value: _vm.localPurchaseLimit.customerId,
                      callback: function ($$v) {
                        _vm.$set(_vm.localPurchaseLimit, "customerId", $$v)
                      },
                      expression: "localPurchaseLimit.customerId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy": "FormPurchaseLimit-itemCode",
                      filled: "",
                      label: _vm.$$t("itemCode"),
                      "item-text": (i) => `${i.itemCode} - ${i.description}`,
                      "item-value": "itemCode",
                      items: _vm.stockItems,
                    },
                    model: {
                      value: _vm.localPurchaseLimit.itemCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.localPurchaseLimit, "itemCode", $$v)
                      },
                      expression: "localPurchaseLimit.itemCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "data-cy": "FormPurchaseLimit-limit",
                      label: _vm.$$t("limit"),
                    },
                    model: {
                      value: _vm.localPurchaseLimit.limit,
                      callback: function ($$v) {
                        _vm.$set(_vm.localPurchaseLimit, "limit", $$v)
                      },
                      expression: "localPurchaseLimit.limit",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormPurchaseLimit-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormPurchaseLimit-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }